export const INIT_CONSULTATION_CONDITION = "INIT_CONSULTATION_CONDITION";
export const INIT_CONSULTATION_CONDITION_DESCENDING_REGIONS =
  "INIT_CONSULTATION_CONDITION_DESCENDING_REGIONS";
